import Backbone from 'backbone';

import template from './generatedFrom.pug';

export class GeneratedFromContextualAttributeView extends Backbone.View {
  initialize({
    pageUrls,
  }) {
    this.Urls = pageUrls;
  }

  render({
    showDeliveryStatusPopup,
  }) {
    const {
      Urls,
    } = this;

    this.$el.html(template({ Urls }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
